import { Component, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, takeUntil } from 'rxjs/operators';
import { Employer } from 'src/app/models/employer';
import { HeaderButton } from 'src/app/models/header-button';
import { AdminService } from 'src/app/services/admin.service';
import { SessionService } from 'src/app/services/session.service';
import { SiteService } from 'src/app/services/site.service';

@Component({
  selector: 'app-admin-template',
  templateUrl: './admin-template.component.html',
  styleUrls: ['./admin-template.component.scss']
})
export class AdminTemplateComponent implements OnInit, OnDestroy {

	public activeLink: string = "users";
	public activeSection: string = '';
	public pageTitle: string = '';
	public headerButtons: Array<HeaderButton> = [];
	public backButton: { title?: string, link: string, queryParams?: any } = null;

	public employer: Employer = null;
	public isSuperAdmin: boolean = false;
	public superAdminEmployerID: number = null;

	// Collapsed = icon strip; hovering it slides the full menu out over the page.
	// Remembered per browser.
	public navCollapsed: boolean = AdminTemplateComponent.readNavCollapsed();
	/** Collapsed menu temporarily shown in full because the mouse is resting on it. */
	public navPeek: boolean = false;
	// Right after clicking Collapse the mouse is still on the menu; don't reopen it until the
	// mouse has left once, or the click would look like it did nothing.
	private suppressPeek: boolean = false;
	private peekTimer: any;
	private static readonly NAV_COLLAPSED_KEY = 'adminNavCollapsed';

	private destroy$: EventEmitter<boolean> = new EventEmitter();

	constructor(private route: ActivatedRoute, private router: Router, private siteService: SiteService, private adminService: AdminService, private sessionService: SessionService) {}

	ngOnInit(): void {
		this.isSuperAdmin = this.adminService.isSuperAdmin;
		this.superAdminEmployerID = this.adminService.employerId

		this.route.firstChild.data.subscribe(d => {
			this.activeLink = d?.activeLink;
		})
		this.activeSection = this.route.snapshot.firstChild?.paramMap.get('tab') || this.route.snapshot.firstChild.data['activeSection'];

		this.router.events.subscribe(e => {
			if(e.type == 11) {
				this.activeLink = e.snapshot.firstChild.data?.activeLink;
				this.activeSection = e.snapshot.firstChild?.paramMap.get('tab') || e.snapshot.firstChild.data['activeSection'];
				window.scrollTo(0, 0);
				this.siteService.headerButtons = [];
				this.siteService.backButton = null;
			}
		});

		this.siteService.onPageTitleSet.subscribe((t) => setTimeout(() => {
			this.pageTitle = t;
		}, 0));

		this.siteService.onHeaderButtonsSet.pipe(takeUntil(this.destroy$)).subscribe((b) => {
			this.headerButtons = b;
		});
		this.siteService.onBackButtonSet.pipe(takeUntil(this.destroy$)).subscribe((b) => {
			this.backButton = b;
		});

		// TODO: Add onShowSubstitutionFields to SiteService if needed
		// this.siteService.onShowSubstitutionFields?.pipe(takeUntil(this.destroy$)).subscribe((show) => {
		// 	this.showSubstitutionFieldsButton = show;
		// });

		this.adminService.onEmployerSet.subscribe((e:Employer) => {
			this.employer = e;
		});

;
	}

	do(callback:Function) {
		callback();
	}

	toggleNav() {
		this.navCollapsed = !this.navCollapsed;
		clearTimeout(this.peekTimer);
		this.navPeek = false;
		this.suppressPeek = this.navCollapsed;
		try { localStorage.setItem(AdminTemplateComponent.NAV_COLLAPSED_KEY, this.navCollapsed ? '1' : '0'); } catch { }
	}

	onNavEnter() {
		if (!this.navCollapsed || this.suppressPeek) return;
		clearTimeout(this.peekTimer);
		// Short delay so sweeping the mouse across the strip doesn't flash the menu open.
		this.peekTimer = setTimeout(() => this.navPeek = true, 150);
	}

	onNavLeave() {
		clearTimeout(this.peekTimer);
		this.navPeek = false;
		this.suppressPeek = false;
	}

	private static readNavCollapsed(): boolean {
		try { return localStorage.getItem(AdminTemplateComponent.NAV_COLLAPSED_KEY) === '1'; } catch { return false; }
	}

	logout() {
		this.sessionService.logout();
		this.router.navigate(['admin', 'login']);
	}

	ngOnDestroy(): void {
		clearTimeout(this.peekTimer);
		this.destroy$.emit(true);
		this.destroy$.complete();
	}
}
